const formatCurrency = (amount) => {
	const currencyCode = window.productData.currency_code;
	const formatSettings = new Intl.NumberFormat(window.locale, {
		style: 'currency',
		currency: currencyCode,
		currencyDisplay: 'symbol',
	});
	switch (currencyCode) {
		case 'CAD':
			return formatSettings.format(amount).replace(/^\D*/, 'C$');
		default:
			return formatSettings.format(amount);
	}
};

export default formatCurrency;
